import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutServiceComponent } from './outservice.component';

@NgModule({
    declarations: [OutServiceComponent],
    imports: [ CommonModule ],
    exports: [OutServiceComponent],
    providers: [],
})
export class OutServiceModule {}